var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_3469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 1.04346H11.4782V11.4782H1.04346V1.04346Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 1.04346H22.9565V11.4782H12.5217V1.04346Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 12.522H11.4782V22.9568H1.04346V12.522Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 12.522H22.9565V22.9568H12.5217V12.522Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_3469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/microsoftLogo.d3f563b3ba3447786520b1be49a8ed00.svg";
export { ForwardRef as ReactComponent };